"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _framerMotion = require("framer-motion");

var _util = require("../../util");

var _icons = require("../../assets/icons");

var _AccordionPanel = require("./AccordionPanel.styles");

var Panel = (0, _base["default"])("div", {
  target: "eyn88dd0",
  label: "Panel"
})(_AccordionPanel.styles.panel, ";");

var AccordionPanel = function AccordionPanel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClickItem = _ref.onClickItem,
      panelKey = _ref.panelKey,
      active = _ref.active,
      title = _ref.title,
      isDefault = _ref.isDefault;
  var handleHeaderClick = (0, _react.useCallback)(function (e) {
    onClickItem(e.currentTarget.dataset.key);
  }, [onClickItem]);
  var handleKeyPress = (0, _react.useCallback)(function (e) {
    (0, _util.handleEnter)(e, handleHeaderClick);
  }, [handleHeaderClick]);
  return (0, _jsxRuntime.jsxs)(Panel, {
    isActive: active,
    className: className,
    "aria-expanded": active,
    children: [(0, _jsxRuntime.jsxs)("div", {
      "data-key": panelKey,
      css: _AccordionPanel.styles.header,
      onClick: handleHeaderClick,
      onKeyPress: handleKeyPress,
      role: "button",
      tabIndex: 0,
      children: [(0, _jsxRuntime.jsx)("div", {
        css: _AccordionPanel.styles.heading,
        children: title
      }), (0, _jsxRuntime.jsx)(_icons.ChevronRight, {})]
    }), (0, _jsxRuntime.jsx)(_framerMotion.motion.div, {
      // The default panel will be open at the intial
      initial: isDefault ? 'open' : 'collapsed',
      animate: active ? 'open' : 'collapsed',
      variants: {
        open: {
          height: 'auto'
        },
        collapsed: {
          height: 0
        }
      },
      transition: {
        duration: 0.35
      },
      children: (0, _jsxRuntime.jsx)("div", {
        children: children
      })
    }, "content")]
  });
};

AccordionPanel.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  className: _propTypes.string,
  panelKey: _propTypes.string.isRequired,
  onClickItem: _propTypes.func,
  active: _propTypes.bool,
  title: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  isDefault: _propTypes.bool
};
AccordionPanel.defaultProps = {
  children: undefined,
  className: undefined,
  onClickItem: function onClickItem() {},
  active: false,
  title: undefined,
  isDefault: false
};
var _default = AccordionPanel;
exports["default"] = _default;
//# sourceMappingURL=AccordionPanel.js.map